/**
 * Display user name
 * @param lastName Last name
 * @param firstName First name
 * @returns Formatted user name or "—" if no first or last name is provided
 */
export const displayName = (lastName?: string, firstName?: string): string =>
	lastName && firstName ? `${lastName} , ${firstName}` : "—";
